export const assessmentTemplate = [
  {
    _id: "0006",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "AAronKrunk",
      createdDate: "2022-03-04T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "msqol",
      omniTypeVersion: 1,
      title: "MSQOL",
      description: "",
      duration: "About 5 minutes",
      directions: null,
      attribution: null,
      validated: null,
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "MSQ1",
          numberText: "1",
          text: "This question hasn't happened yet",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: null,
          answerOptions: [
            {
              value: "0",
              text: "TBD",
              displayType: "To Be Determined",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
        // scoring: [
        //   {
        //     scoreTitle: "Physical Health",
        //     scoreID: "PH",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm:
        //       "({MSQ3.answerValue}+{MSQ4.answerValue}+{MSQ5.answerValue}+{MSQ6.answerValue}+{MSQ7.answerValue}+{MSQ8.answerValue}+{MSQ9.answerValue}+{MSQ10.answerValue}+{MSQ11.answerValue}+{MSQ12.answerValue})/10",
        //   },
        //   {
        //     scoreTitle: "Role limitations due to physical problems",
        //     scoreID: "RLPP",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: "5",
        //     algorithm:
        //       "({MSQ13.answerValue}+{MSQ14.answerValue}+{MSQ15.answerValue}+{MSQ16.answerValue})/4",
        //   },
        //   {
        //     scoreTitle: "Role limitations due to emotional problems",
        //     scoreID: "RLEP",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm: "({MSQ17.answerValue}+{MSQ18.answerValue}+{MSQ19.answerValue})/3",
        //   },
        //   {
        //     scoreTitle: "Pain",
        //     scoreID: "P",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm: "({MSQ21.answerValue}+{MSQ22.answerValue}+{MSQ52.answerValue})/3",
        //   },
        //   {
        //     scoreTitle: "Emotional well-being",
        //     scoreID: "EWB",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm:
        //       "({MSQ24.answerValue}+{MSQ25.answerValue}+{MSQ26.answerValue}+{MSQ28.answerValue}+{MSQ30.answerValue})/5",
        //   },
        //   {
        //     scoreTitle: "Energy",
        //     scoreID: "E",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm:
        //       "({MSQ23.answerValue}+{MSQ27.answerValue}+{MSQ29.answerValue}+{MSQ31.answerValue}+{MSQ32.answerValue})/5",
        //   },
        //   {
        //     scoreTitle: "Health Perceptions",
        //     scoreID: "HP",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm:
        //       "({MSQ1.answerValue}+{MSQ34.answerValue}+{MSQ35.answerValue}+{MSQ36.answerValue}+{MSQ37.answerValue})/5",
        //   },
        //   {
        //     scoreTitle: "Social function",
        //     scoreID: "SF",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm: "({MSQ20.answerValue}+{MSQ33.answerValue}+{MSQ51.answerValue})/3",
        //   },
        //   {
        //     scoreTitle: "Cognitive function",
        //     scoreID: "CF",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm:
        //       "({MSQ42.answerValue}+{MSQ43.answerValue}+{MSQ44.answerValue}+{MSQ45.answerValue})/4",
        //   },
        //   {
        //     scoreTitle: "Health distress",
        //     scoreID: "HD",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm:
        //       "({MSQ38.answerValue}+{MSQ39.answerValue}+{MSQ40.answerValue}+{MSQ41.answerValue})/4",
        //   },
        //   {
        //     scoreTitle: "Sexual function",
        //     scoreID: "SF",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm:
        //       "({MSQ46.answerValue}+{MSQ47.answerValue}+{MSQ48.answerValue}+{MSQ49.answerValue})/4",
        //   },
        //   {
        //     scoreTitle: "Change in health",
        //     scoreID: "CH",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm: "{MSQ2.answerValue}",
        //   },
        //   {
        //     scoreTitle: "Satisfaction with sexual function",
        //     scoreID: "SSF",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm: "{MSQ50.answerValue}",
        //   },
        //   {
        //     scoreTitle: "Overall quality of life",
        //     scoreID: "QOL",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm: "(({MSQ53.answerValue}*10), {MSQ54.answerValue.answerValue})/2",
        //   },
        //   {
        //     scoreTitle: "Physical Health Composite Score",
        //     scoreID: "PHCS",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: true,
        //     algorithm:
        //       "(({PH.finalResult}*.17)+({HP.finalResult}*.17)+({E.finalResult}*.12.answerValue})+({RLPP.finalResult}*.12.answerValue})+({P.finalResult}*.12.answerValue})+({QOL.finalResult}*.12.answerValue})+({SSF.finalResult}*.12.answerValue})+({SF.finalResult}*.12.answerValue})+({HD.finalResult}*.12.answerValue}))",
        //   },
        //   {
        //     scoreTitle: "Mental Health Composite Score",
        //     scoreID: "MHCS",
        //     scoreMin: "0",
        //     scoreMax: "100",
        //     finalResult: null,
        //     isDefault: false,
        //     algorithm:
        //       "(({HD.finalResult}*.17)+({QOL.finalResult}*.17)+({EWB.finalResult}*.12.answerValue})+({RLEE.finalResult}*.12.answerValue})+({CF.finalResult}*.12.answerValue}))",
        //   },
        // ],
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "msqol",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
